<template>
  <div class="service-detail-page">
    <!-- 文章详情 -->
    <div class="page_news_show">
      <div class="dg">
        <router-link to="/">主页</router-link> &gt;
        <router-link to="/services">服务介绍</router-link> &gt;
        <span style="font-size: 13px;">{{menu}}</span>
      </div>
      <div class="page_news_list_show">
        <left>
          <div class="news_show_contact">
            <h1>{{currentService.newNameCn}}</h1>
            <h2>
              <span>发布时间：{{ currentService.createTime }}</span>
              <span>浏览次数： {{ currentService.pageView }}</span>
              <span>来源于：网络</span>
            </h2>
            <div class="content-body"  v-html="formatContent(currentService.newContentCn)"></div>
            <h3></h3>
            <h4>
              <c>
                <a v-if="nextService" @click="goToDetail(nextService)">下一篇：{{ nextService.newNameCn }}</a>
                <a v-else>下一篇：暂无</a>
              </c>
              <c>
                <a v-if="prevService" @click="goToDetail(prevService)">上一篇：{{ prevService.newNameCn }}</a>
                <a v-else>上一篇：暂无</a>
              </c>
            </h4>
          </div>
        </left>
        <right>
          <div class="news_list_right_bottom">
            <h1>
              <g><img src="@/assets/images/news_list_right_bottom_ino.png"></g>
              <k>相关新闻推荐</k>
            </h1>
            <div v-if="relatedServices.length > 0">
              <dl>
                <dd v-for="(item, index) in relatedServices" :key="index">
                  <a @click="goToDetail(item)">
                    <c><img src="@/assets/images/news_list_right_bottom_jt.png"></c>
                    <b>
                      <e>{{ item.newNameCn }}</e>
                      <f>{{ item.createTime }}</f>
                    </b>
                  </a>
                </dd>
              </dl>
            </div>
            <div v-else class="no-related-news">暂无相关新闻推荐</div>
          </div>
        </right>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServiceDetail',
  data() {
    return {
      service: [],
      currentService: {},
      menu: ''
    }
  },
  computed: {
    // 相关新闻推荐（排除当前文章）
    relatedServices() {
      const currentId = this.$route.query.id
      return this.service.filter(item => item.id != currentId).slice(0, 5)
    },
    // 上一篇文章
    prevService() {
      const id = this.$route.query.id
      if (!this.service || this.service.length === 0) return null
      const index = this.service.findIndex(item => item.id == id)
      console.log('prevService computed - id:', id, 'index:', index, 'service length:', this.service.length)
      if (index > 0) {
        return this.service[index - 1]
      }
      return null
    },
    // 下一篇文章
    nextService() {
      const id = this.$route.query.id
      if (!this.service || this.service.length === 0) return null
      const index = this.service.findIndex(item => item.id == id)
      console.log('nextService computed - id:', id, 'index:', index, 'service length:', this.service.length)
      if (index >= 0 && index < this.service.length - 1) {
        return this.service[index + 1]
      }
      return null
    }
  },
  methods: {
    // 格式化内容，处理图片路径和HTML样式
    formatContent(content) {
      if (!content) return ''
      let html = content
      
      // 1. 处理图片路径 - 将相对路径转换为require引入
      html = html.replace(/<img[^>]+src="([^"]+)"/g, (match, src) => {
        // 如果已经是完整路径，不做处理
        if (src.startsWith('http') || src.startsWith('data:')) {
          return match
        }
        // 提取文件名
        const fileName = src.split('/').pop()
        try {
          return match.replace(src, require('@/assets/images/' + fileName))
        } catch (e) {
          // 如果require失败，保持原样
          return match
        }
      })
      
      // 2. 移除空的p标签和br标签（清理冗余）
      html = html.replace(/<p>\s*<br\s*\/?>\s*<\/p>/g, '')
      html = html.replace(/<p>\s*<\/p>/g, '')
      
      // 3. 处理span的font-family样式，统一使用宋体
      html = html.replace(/font-family:[^;]+/g, 'font-family:宋体')
      
      return html
    },
    getService() {
      // 获取该分类下所有文章，pageSize传大一点获取全部
      this.$request.get('/wx/news/getListByClassIfy',{"newType": this.$route.query.type, "pageSize": 100} ).then(response => {
        this.service = response.data.records
        const id = this.$route.query.id || ''
        // 找到当前文章
        this.currentService = response.data.records.find(item => item.id == id) || {}
      })
    },
    addPageView() {
      this.$request.get('/wx/news/addPageView',{"newId": this.$route.query.id} )
    },

    // 跳转到详情
    goToDetail(service) {
      this.$router.push({
        path: '/services/detail',
        query: { 
          id: service.id,
          menu: this.menu,
          type: this.$route.query.type
        }
      })
    }
  },
    watch: {
    '$route.query.id'() {
      this.addPageView()
      this.getService()
    }
  },
  created() {
    this.menu = this.$route.query.menu || ''
    this.addPageView()
    this.getService()
  },
  metaInfo() {
    const title = this.currentService.newNameCn || '服务详情'
    const synopsis = this.currentService.newSynopsisCn || '南京华合半导体提供专业化合物半导体技术服务'
    return {
      title: `${title}_${this.menu || '服务介绍'}_南京华合半导体`,
      meta: [
        { name: 'description', content: synopsis },
        { name: 'keywords', content: `${title},${this.menu},化合物半导体,器件模型,PDK开发,IP设计,南京华合半导体` },
        { name: 'robots', content: 'index,follow' }
      ]
    }
  }
}
</script>

<style scoped>
/* 文章内容样式 */
.content-body {
  font-size: 14px;
  line-height: 1.8;
  color: #333;
  padding: 20px 0;
  
}
/* .documentation h3, p {
    text-align: left;
} */

.content-body >>> p {
  /* margin-bottom: 16px;    */
  text-indent: 2em;
  text-align: left !important;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.content-body >>> img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 20px auto;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.content-body span {
  font-family: '宋体', SimSun, serif;
}

/* 移动端适配 */
@media screen and (max-width: 740px) {
  .content-body {
    font-size: 13px;
    padding: 10px 0;
  }
  
  .content-body >>> p {
    margin-bottom: 12px;
    text-align: left !important;
  }
  
  .content-body >>> img {
    max-width: 100%;
    margin: 15px auto;
  }
}

/* 覆盖右侧相关新闻的margin-top */
.service-detail-page >>> .news_list_right_bottom {
  margin-top: 0 !important;
}

/* 暂无相关新闻推荐样式 */
.no-related-news {
  padding: 20px;
  text-align: center;
  color: #999;
  font-size: 14px;
}
</style>
